type SupportedValuesOf = (key: "timeZone") => string[];

export const listTimeZones = (): string[] => {
	const supported = (Intl as unknown as { supportedValuesOf?: SupportedValuesOf })
		.supportedValuesOf;
	return supported ? supported("timeZone") : [];
};
